export enum CegidExportErrorMotifEnum {
  COMPTE_COMPTABLE_MANQUANT = 'COMPTE_COMPTABLE_MANQUANT',
  TAXE_MANQUANTE = 'TAXE_MANQUANTE',
  TAXE_COMPTE_COMPTABLE_MANQUANT = 'TAXE_COMPTE_COMPTABLE_MANQUANT'
}

export const CEGID_EXPORT_ERROR_MOTIF_LABELS: Record<CegidExportErrorMotifEnum, string> = {
  [CegidExportErrorMotifEnum.COMPTE_COMPTABLE_MANQUANT]:      'Compte comptable manquant',
  [CegidExportErrorMotifEnum.TAXE_MANQUANTE]:                 'Taxe manquante',
  [CegidExportErrorMotifEnum.TAXE_COMPTE_COMPTABLE_MANQUANT]: 'Code compte comptable de la taxe manquant',
};
